import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { ENPOINT } from '../endpoint';

import { Options } from 'selenium-webdriver/safari';
import { GLOBAL } from '../global';

@Injectable()
export class MyVouchersService {

  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;

  cargarFacturaMasiva(body): Observable<any> {
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders({
      // "Content-Type": "multipart/form-data"
    });
    
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };

    return this.http.post<any>(this.basePath + 'comprobante', body, options);
  }

  getReporte(fechaI, fechaF, factura, proveedor): Observable<any> {
    // tslint:disable-next-line:max-line-length
    var urlExtension = "";
    let flagFact = false, flagProveedor = false;

    if (factura !== null && factura !== undefined && factura !== "") {
      flagFact = true;
    }
    if (proveedor !== null && proveedor !== undefined && proveedor !== "") {
      flagProveedor = true;
    }

    if (flagFact  && flagProveedor) {
      urlExtension = "?fechaInicial="+fechaI+"&fechaFinal="+fechaF+"&noDocumento="+factura+"&proveedor="+proveedor;
    } else if (flagFact && !flagProveedor) {
      urlExtension = "?fechaInicial="+fechaI+"&fechaFinal="+fechaF+"&noDocumento="+factura;
    } else if (!flagFact && flagProveedor) {
      urlExtension = "?fechaInicial="+fechaI+"&fechaFinal="+fechaF+"&proveedor="+proveedor;
    }

    const httpHeaders = new HttpHeaders()
    const options = {
      headers: httpHeaders,
      withCredentials: true
    }

    return this.http.get(this.basePath + 'comprobante'+urlExtension, options);
  }
  
  idRelacionados(id): Observable<any> {
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders();
    
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };

    return this.http.get(this.basePath + 'master-factura/comprobantes/'+id, options);
  }

  downloadPdf(url: string) {
    return this.http.get(`${this.basePath}comprobante/${url}`, { 
      responseType: 'blob',
    });
  }

  downloadExcelReport(params): Observable<any> {
    return this.http.get(`${this.basePath}comprobante/excel${params}`, { 
      responseType: 'blob' 
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/my-vouchers/my-vouchers.service.ts